import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-wifi-line', key: 'wifi' },
    { icon: 'ri-parking-box-line', key: 'parking' },
    { icon: 'ri-restaurant-line', key: 'kitchen' },
    { icon: 'ri-sun-line', key: 'terrace' },
    { icon: 'ri-fire-line', key: 'heating' },
    { icon: 'ri-tv-line', key: 'tv' },
    { icon: 'ri-shirt-line', key: 'washing' },
    { icon: 'ri-bike-line', key: 'bike' },
  ];

  return (
    <section id="features" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">
              {t('features.title')}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3">
              {t('features.subtitle')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((feature) => (
              <div
                key={feature.key}
                className="group p-6 bg-background-50 rounded-lg transition-all hover:bg-primary-50"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feature.icon} text-2xl`} />
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-900">
                  {t(`features.items.${feature.key}.title`)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {t(`features.items.${feature.key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}